import {Component, Input, OnInit} from '@angular/core';
import {TransportInterventionPoiGroupReport} from 'shared';

@Component({
  selector: 'app-transport-interventions-map-poi-report-popup',
  templateUrl: './transport-interventions-map-poi-report-popup.component.html',
  styleUrls: ['./transport-interventions-map-poi-report-popup.component.scss']
})
export class TransportInterventionsMapPoiReportPopupComponent implements OnInit {

  @Input()
  report: TransportInterventionPoiGroupReport;

  selectedIndex = 0;
  tabs = [
    {text: 'Rapport'},
    {text: 'Visites'},
  ];

  constructor() {
  }

  ngOnInit(): void {
  }

}

